export default {
  groupName: 'nissan',
  appName: 'Nissan',
  isAuto: true,
  image: 'nissan.png',
  baseRoute: '/nissan',
  description:
    'Nissan Advertising Dashboard'
}



// WEBPACK FOOTER //
// ./src/app/configuration/Nissan/config/main.js